import React from 'react';

import PropTypes from 'prop-types';

import { emptyArray } from 'ui-components/default-props/empty';
import { FulfillmentPlanOrderGridStatus } from '../../../enums/fulfillmentplan-order-grid-status';
import style from './ship-together-destination-modal.module.less';
import { FulfillmentPlanSelector } from './fulfillment-plan-selector';

export const FulfillmentPlanSelectorList = ({
  onFulfillmentPlanSelected,
  fulfillmentPlansWithCombineDetails = emptyArray,
  sellerServices = emptyArray,
  selectedFulfillmentPlanId = '',
  selectedOrderIds,
}) => {
  const isAwaitingShipment = FulfillmentPlanOrderGridStatus.AwaitingShipment.name;
  const plansToShowMap = {};
  const plansToShow = fulfillmentPlansWithCombineDetails.reduce((acc, fp) => {
    if (
      !plansToShowMap[fp.fulfillmentPlanId] &&
      fp.orderGridStatus === isAwaitingShipment &&
      selectedOrderIds.includes(fp.fulfillmentPlanId)
    ) {
      plansToShowMap[fp.fulfillmentPlanId] = fp;
      return acc.concat(fp);
    }
    return acc;
  }, []);
  return (
    <div className={style['address-selector-list']}>
      {plansToShow.map(({ marketplaceId, orderNumber, shipTo, notes, fulfillmentPlanId, totalItemQuantity, serviceId }) => {
        const selectedService = sellerServices.find((service) => {
          return service.serviceId === serviceId;
        });
        return (
          <FulfillmentPlanSelector
            key={fulfillmentPlanId}
            address={shipTo}
            fulfillmentPlanId={fulfillmentPlanId}
            isSelected={fulfillmentPlanId === selectedFulfillmentPlanId}
            marketplaceId={marketplaceId}
            notes={notes}
            numOfItems={totalItemQuantity}
            onFulfillmentPlanSelected={onFulfillmentPlanSelected}
            orderNumber={orderNumber}
            selectedService={selectedService?.name || ''}
          />
        );
      })}
    </div>
  );
};

FulfillmentPlanSelectorList.propTypes = {
  onFulfillmentPlanSelected: PropTypes.func.isRequired,
  fulfillmentPlansWithCombineDetails: PropTypes.array,
  sellerServices: PropTypes.array,
  selectedFulfillmentPlanId: PropTypes.string,
};
